<script>
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import {useRoute} from "vue-router";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import BuyBox from "@/components/assetComponents/BuyBox.vue";
import {useStore} from "vuex";
import {Share} from '@capacitor/share';
import VideoPage from "@/components/assetComponents/VideoPage.vue";


export default {
  name: "DetailsProducts",
  components: {VideoPage, BuyBox, LoadingPage},

  setup() {

    let store = useStore()
    let orders = store.state.order

    let background = ref(false)
    let loading = ref(false)
    let prod = ref(null)
    let pid = useRoute().params.pid

    let video_src = ref(store.state.info.video_cart)
    let video_play = ref(false)

    let marked = ref(false)
    let sort = ref('')

    let buy_box = ref(false)

    if (orders.products.length > 0) buy_box.value = true

    function details_prod() {

      loading.value = true
      FreeWorld.Heisenberg({pid: pid}, 'product', true).then((res) => {

        loading.value = false
        prod.value = res.data
        prod.value.shops.forEach((item) => {
          item.number = 0
        })

        prod.value.pics = prod.value.pics.filter(pic => pic !== 'https://market-app.ir/resources/files/pics/nopic.jpg')

        orders.products.forEach((item) => {
          if (item.pid === prod.value.id) {
            prod.value.shops.forEach((shop) => {
              if (item.shop.id === shop.id) {
                shop.number = item.shop.number
                buy_box.value = true
              }
            })
          }
        })

        marked.value = res.data.mark
        filter_shop('rate')

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, details_prod)
      })

    }

    details_prod()

    function open_sort() {

      let filter_sort = document.getElementById('filter_sort')

      if (filter_sort.style.height !== '22rem') {
        filter_sort.style.height = '22rem'
        background.value = true
      } else {
        filter_sort.style.height = '0'
        background.value = false
      }

    }

    function filter_shop(type, close) {

      if (type === 'rate') {
        let i
        i = prod.value.shops.sort((a, b) => b.rate - a.rate);
        prod.value.shops = i
        sort.value = type
        if (close) {
          open_sort()
        }
      }

      if (type === 'price') {
        let i
        i = prod.value.shops.sort((a, b) => a.price - b.price);
        prod.value.shops = i
        sort.value = type
        open_sort()
      }

      if (type === 'sold') {
        let i
        i = prod.value.shops.sort((a, b) => b.sold - a.sold);
        prod.value.shops = i
        sort.value = type
        open_sort()
      }

    }

    function update_orders(shop) {

      if (shop.local === 1) {
        if (store.state.profile.prov_id !== shop.prov_id) {
          Swals.Warning('متاسفانه فروشگاه مورد نظر شما این محصول را به استان شما ارسال نمیکند!')
          return false
        }
      }

      if (orders.products.length === 0) {

        let order = {}
        order.name = prod.value.name
        order.pid = prod.value.id
        order.pic = prod.value.pic
        order.shop = shop
        shop.number++

        store.commit('set_offer', null)
        store.commit('ProductUpdate', order)

      } else {

        if (orders.products[0].shop.id !== shop.id || orders.offer !== null) {
          let type
          if (orders.offer !== null) type = 'offer'
          Swals.Orders(type).then((res) => {

            if (res.isConfirmed) {
              store.commit('EmptyBasket')

              prod.value.shops.forEach((item) => {
                item.number = 0
              })

              let order = {}
              order.name = prod.value.name
              order.pid = prod.value.id
              order.pic = prod.value.pic
              order.shop = shop
              shop.number++
              store.commit('set_offer', null)
              store.commit('ProductUpdate', order)

              video_play.value = true
            }
            if (res.dismiss) video_play.value = true

          })

        } else {

          // *** 'برای پیدا کردن محصولاتی که ارسال به یک استان هستند یا به کل کشور' ***
          let found_local = false
          orders.products.forEach((item) => {
            if (item.shop.local !== shop.local) {
              Swals.Warning('متاسفانه طریقه ارسال این محصول با محصولات سبد خرید شما همخوانی ندارد!')
              found_local = true
              video_play.value = true
              return false
            }
          })
          if (found_local) return false
          // ****

          let found = false
          orders.products.forEach((item) => {
            if (item.pid === prod.value.id) {
              let order = {}
              order.name = prod.value.name
              order.pid = prod.value.id
              order.pic = prod.value.pic
              order.shop = shop
              store.commit('set_offer', null)
              store.commit('ProductUpdate', order)

              found = true
            }
          })

          if (!found) {
            let order = {}
            order.name = prod.value.name
            order.pid = prod.value.id
            order.pic = prod.value.pic
            order.shop = shop
            shop.number++
            store.commit('set_offer', null)
            store.commit('ProductUpdate', order)

          }

        }

      }


      if (store.state.order.products.length > 0) {
        buy_box.value = true
      } else {
        setTimeout(() => {
          buy_box.value = false
        }, 500)
      }

    }

    function mark_prod() {

      let div_mark = document.getElementById('mark')
      marked.value = !marked.value
      div_mark.style.pointerEvents = 'none'
      FreeWorld.Heisenberg({action: 'marking', pid: prod.value.id}, 'info', true).then((res) => {

        if (res.data.event === 'marked') {
          marked.value = true
        } else if (res.data.event === 'unmarked') {
          marked.value = false
        }
        div_mark.style.pointerEvents = 'auto'

      }).catch(() => {
        Swals.Warning('متاسفانه محصول مورد نظر نشان نشد')
        div_mark.style.pointerEvents = 'auto'
        marked.value = !marked.value
      })

    }

    async function share_prod() {
      await Share.share({
        title: prod.value.name,
        text: 'اپلیکیشن اپ مارکت :' + prod.value.name,
        url: 'https://market-app.ir/',
        dialogTitle: 'اشتراک گذاری برای دیگران',
      });
    }

    return {

      open_sort,
      background,
      prod,
      loading,
      marked,
      filter_shop,
      sort,
      update_orders,
      buy_box,
      mark_prod,
      share_prod,
      video_src,
      video_play,
      orders,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div v-if="video_play" @click="video_play = false" class="bg_dialog"></div>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div @click="open_sort" v-if="background" class="bg_dialog"></div>


    <div class="div-top-arrow d-flex align-items-center justify-content-between shadow-custom bg-white">
      <div class="d-flex justify-content-between w-25">
        <div id="mark">
          <img @click="mark_prod" v-if="!marked" :class="prod === null ? 'pe-none':'' " class="icon_mark"
               src="../assets/img/bookmark_dont_active.svg" alt="">
          <img @click="mark_prod" v-else :class="prod === null ? 'pe-none':'' " class="icon_mark"
               src="../assets/img/marked.svg" alt="">
        </div>

        <img @click="share_prod" class="icon_mark" src="../assets/img/icon_share_color.svg" alt="">
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">مشخصات محصول</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div v-if="prod != null" class="p-body mt-3">

      <div class="slider mb-3">
        <!--        <img class="w-100 h-100 rounded-4" :src="prod.pic" alt="">-->
        <v-carousel
            class="slider rounded-4 "
            :show-arrows="false"
            hide-delimiter-background>
          <v-carousel-item
              v-for="(pic,index) in prod.pics"
              :key="index"
              class="w-100 h-100 rounded-4"
              :src="pic"
              cover
          ></v-carousel-item>
        </v-carousel>
      </div>

      <div class="d-flex align-items-center bg-white rounded-4 justify-content-between p-3 mb-3">
        <div class="overflow-hidden ml-2">
          <p class="font-4 font-color font-bold" :class="{'txtoverflow': prod.name.length > 35}">{{ prod.name }}</p>
        </div>

        <div class="d-flex align-items-center justify-content-end w-35">
          <img style="height: 1.5rem" class="ml-2" src="../assets/img/store_color.svg" alt="">
          <p style="white-space: nowrap" class="font-4">{{ prod.shops_count }} فروشگاه</p>
        </div>
      </div>

      <div style="min-height: 130px" class="bg-white p-3 rounded-4 mb-3">
        <p class="font-4 font-color font-bold mb-2">توضیحات محصول</p>
        <div v-html="prod.description" class="font-5"></div>
      </div>

      <div class="d-flex align-items-center justify-content-between rounded-4 p-3 mb-3 bg-white">
        <p class="font-bold font-color font-4">برند</p>
        <p class="font-4">{{ prod.brand }}</p>
      </div>

      <div class="d-flex align-items-center justify-content-between rounded-4 p-3 mb-3 bg-white">
        <p class="font-bold font-color font-4">واحد محصول</p>
        <p class="font-4">{{ prod.unit }}</p>
      </div>

      <div class="bg-white p-3 rounded-4 mb-3">

        <div class="d-flex align-items-center justify-content-between mb-3">
          <p class="font-4 font-bold font-color">فروشندگان</p>

          <img @click="open_sort" class="icon_filter" src="../assets/img/filter_sort_bgLight.svg" alt="">
        </div>

        <div v-if="prod.shops.length !== 0" class="">

          <div v-for="item in prod.shops" :key="item.id"
               class="animate__animated animate__fadeInRight bg-color-blue-light rounded-4 p-2 mb-3">
            <router-link :to="{name:'StorePage',params:{sid:item.id,shopname:item.shopname }}"
                         class="text-decoration-none text-black d-flex align-items-center mb-2">
              <img style="height: 15px" class="" src="../assets/img/arrow_color.svg" alt="">

              <p class="font-4 mx-2">{{ item.shopname }}</p>

              <img class="icon-size-1" v-if="item.rate == 1" src="../assets/img/rate1.svg" alt="">
              <img class="icon-size-8" v-else-if="item.rate == 2" src="../assets/img/rate2.svg" alt="">
              <img class="icon-size-1" v-else-if="item.rate == 3" src="../assets/img/rate3.svg" alt="">
              <img class="icon-size-8" v-else-if="item.rate == 4" src="../assets/img/rate4.svg" alt="">
              <img class="icon-size-1" v-else-if="item.rate == 5" src="../assets/img/rate5.svg" alt="">
              <img class="icon-size-8" v-else-if="item.rate == 6" src="../assets/img/rate6.svg" alt="">
            </router-link>

            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <p v-if="item.price !== item.price_show" class="font-5 d-flex text-decoration-line-through">
                  {{ item.price.toLocaleString() }}</p>
                <p class="font-4 font-color d-flex mr-2">
                  <span class="">{{ item.price_show.toLocaleString() }}</span>
                  <span class="mr-1">تومان</span>
                </p>
              </div>


              <div v-if="item.number !== 0 && orders.offer === null"
                   class="div_mojodi shadow-custom w-35 d-flex align-items-center justify-content-between p-1 rounded-pill">
                <img @click="item.number++; update_orders(item)" src="../assets/img/icon_plus.svg" alt=""
                     class="icon_plus icon_shadow">
                <p class="font-4 font-bold">{{ item.number }}</p>
                <img @click="item.number--; update_orders(item)" src="../assets/img/icon_min.svg" alt=""
                     class="icon_plus icon_shadow">
              </div>

              <div v-else @click="update_orders(item)" class="bg-green p-2 rounded-pill d-flex align-items-center">
                <img style="width: 15px" src="../assets/img/add-to-cart-withe.svg" alt="" class="">
                <p class="font-5 text-white mr-2">افزودن به سبد خرید</p>
              </div>
            </div>

            <div class="hr_shop my-2"></div>

            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex">
                <img src="../assets/img/google-place.svg" alt="" class="icon_shop">
                <p class="font-5 mr-1">{{ item.city }}</p>
              </div>

              <div class="d-flex">
                <img src="../assets/img/van.svg" alt="" class="icon_shop">
                <p v-if="item.local === 0" class="font-5 mr-1">ارسال به سراسر کشور</p>
                <p v-else class="font-5 mr-1">ارسال فقط به {{ item.prov }}</p>
              </div>

              <div class="d-flex">
                <img src="../assets/img/add-to-cart-color.svg" alt="" class="icon_shop">
                <p class="font-5 mr-1">{{ item.sold }} فروش</p>
              </div>
            </div>
          </div>

        </div>

        <p v-else class="font-4 font-color-red font-bold text-center">فروشنده ای وجود ندارد</p>

      </div>

    </div>

    <router-link :to="{name:'CartPage'}">
      <BuyBox v-if="buy_box"></BuyBox>
    </router-link>


    <div id="filter_sort" class="filter_sort rounded-top-5 max_width bg-white shadow-custom py-3 px-5">

      <div @click="open_sort" class="hr_sort rounded-pill mb-4"></div>

      <div class="">

        <p class="font-4 text-center">مرتب سازی فروشندگان :</p>
        <hr>
        <p @click="filter_shop('rate' , true)" :class="sort === 'rate' ? 'font-bold font-color font-3':'font-4' "
           class="text-center">بر اساس ستاره</p>
        <hr>
        <p @click="filter_shop('price')" :class="sort === 'price' ? 'font-bold font-color font-3':'font-4' "
           class="text-center">نزولی بر اساس قیمت</p>
        <hr>
        <p @click="filter_shop('sold')" :class="sort === 'sold' ? 'font-bold font-color font-3':'font-4' "
           class="font-4 text-center">پر فروش ترین</p>

      </div>

    </div>


    <VideoPage v-if="video_play" :src="video_src"></VideoPage>

  </div>

</template>


<style scoped>

@media (min-width: 1000px) {
  .slider{
    height: 20rem!important;
  }
}
@media (max-width: 999px) {
  .slider{
    height: 15rem!important;
  }
}

.slider {
  width: 100%;
}
.icon_mark {
  width: 1.5rem;
  height: 1.5rem;
}
.icon_filter {
  width: 3rem;
  height: 3rem;
}
.hr_shop {
  width: 100%;
  height: 1px;
  border: 1px white dashed;
}
.icon_shop {
  width: 1.5rem;
  height: 1.5rem;
}
.filter_sort {
  height: 0;
  width: 100%;
  position: fixed;
  bottom: -50px;
  overflow: hidden;
  transition: .5s;
  z-index: 6;
}
.hr_sort {
  width: 60%;
  height: 8px;
  background-color: #DCF4FF;
  margin: 0 auto;
}
.icon_plus {
  width: 2rem;
  height: 2rem;
}
.div_mojodi {
  border: 1px solid #00F593;
}
li::marker{
  margin: 0 1rem !important;
}
</style>